import React, {useContext} from 'react';
import useSubmittingButton from "../../hooks/useSubmittingButton";
import {runScript} from "../../services";
import {Col, Row} from "reactstrap";
import {ModalContext} from "../../Modal/ModalProvider";

const BusinessAppUsersReport = () => {
    const {successMessage, errorMessage, loader, SubmittingButton} = useSubmittingButton();
    const {showModal} = useContext(ModalContext);

    const handleSubmit = async () => {
        const response = await runScript('MerchantUsersReport', {});

        if (response.status === 200) {
            const data = await response.json();

            showModal({
                type: 'download',
                exportId: data.id,
            });
        }
        else {
            throw new Error(`${response.status}: ${response.statusText}. Contact a site administrator. This error probably won't go away by itself.`);
        }
    };

    return (
        <>
            <h4>Business App Users Report</h4>

            {errorMessage}

            <form style={{maxWidth: 600}}>

                {successMessage}

                <Row form className="align-items-center">
                    <Col xs="auto">
                        <SubmittingButton onClick={handleSubmit}>Download XLSX</SubmittingButton>
                    </Col>
                    <Col xs="auto">
                        {loader}
                    </Col>
                </Row>
            </form>
        </>
    );
};

export default BusinessAppUsersReport;